import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/home/Index.vue'
import Printer from './printer.js'

Vue.use(Router)
// route level code-splitting
// this generates a separate chunk (about.[hash].js) for this route
// which is lazy-loaded when the route is visited.
// permissions: ['users', 'groups', 'send', 'financial', 'events', 'a4l']
const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {protect: false},
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      meta: {protect: false},
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/auth/signin',
      meta: {auth: true, protect: false},
      component: () => import(/* webpackChunkName: "auth" */'@/views/auth/Signin'),
    },
    {
      path: '/auth/signup',
      meta: {auth: true, protect: false},
      component: () => import(/* webpackChunkName: "auth" */'@/views/auth/Signup')
    },
    {
      path: '/auth/confirm',
      meta: {auth: true, protect: false},
      component: () => import(/* webpackChunkName: "auth" */'@/views/auth/Confirm')
    },
    {
      path: '/auth/recover',
      meta: {auth: true, protect: false},
      component: () => import(/* webpackChunkName: "auth" */'@/views/auth/Recover'),
    },
    {
      path: '/auth/resetpassword',
      meta: {auth: true, protect: false},
      component: () => import(/* webpackChunkName: "auth" */'@/views/auth/ResetPassword')
    },
    {
      path: '/auth/inviteconfirm',
      meta: {auth: true, protect: false},
      component: () => import(/* webpackChunkName: "auth" */'@/views/auth/InviteConfirm')
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      meta: {protect: true},
      component: () => import(/* webpackChunkName: "dashboard" */'@/views/Dashboard')
    },

    {
      path: '/contacts',
      name: 'contacts',
      meta: {protect: true, permissions: ['contacts']},
      component: () => import(/* webpackChunkName: "contacts" */'@/views/contacts/Index'),
      children: [
        {
          path: 'edit/:uuid',
          component: () => import(/* webpackChunkName: "contacts" */ '@/components/contacts/ContactEditor'),
          props: true
        }
      ]
    },


    {
      path: '/send',
      name: 'send',
      meta: {protect: true, permissions: ['send']},
      component: () => import(/* webpackChunkName: "send" */'@/views/Send')
    },
    {
      path: '/groupcontact',
      name: 'groupcontact',
      meta: {protect: true, permissions: ['contacts', 'groups']},
      component: () => import(/* webpackChunkName: "groups" */'@/views/GroupContactView')
    },
    {
      path: '/history',
      name: 'history',
      meta: {protect: true, permissions: ['send']},
      component: () => import(/* webpackChunkName: "history" */'@/views/HistoryView')
    },
    //EVENTS AND REGISTRATION
    {
      path: '/events',
      name: 'event',
      meta: {protect: true, permissions: ['events']},
      component: () => import(/* webpackChunkName: "events" */ '@/views/event/Index.vue' ),
      children: [
        {
          path: '',
          name: 'eventlist',
          component: () => import(/* webpackChunkName: "events" */ '@/views/event/EventTable.vue')
        },
        {
          path: 'keys',
          name: 'poolkeys',
          component: () => import(/* webpackChunkName: "events" */ '@/views/event/PoolKeys')
        },
        {
          path: 'edit/:eventid',
          name: 'eventedit',
          component: () => import(/* webpackChunkName: "events" */ '@/views/event/EditEvent.vue')
        },
        {
          path: 'registration/:eventid',
          name: 'registrationlist',
          component: () => import(/* webpackChunkName: "events" */ '@/views/event/RegistrationList.vue')
        },
        {
          path: 'brackets/:eventid',
          name: 'brackets',
          component: () => import(/* webpackChunkName: "events" */ '@/views/event/Brackets.vue')
        }
      ]
    },

    //CUSTOMERS AND BILLINGS
    {
      path: '/customers',
      name: 'Customers',
      meta: {protect: true, permissions: ['contacts']},
      component: () => import(/* webpackChunkName: "customers" */ '@/views/customers/Index'),
      children: [
        {
          path: 'list',
          name: 'List Customers',
          component: () => import(/* webpackChunkName: "customers" */ '@/views/customers/Customers.vue')
        },
        {
          path: 'search',
          name: 'Search + Create',
          component: () => import(/* webpackChunkName: "customers" */ '@/views/customers/SearchUsers.vue')
        }
      ]
    },


    {
      path: '/groups',
      name: 'groups',
      meta: {protect: true, permissions: ['groups']},
      component: () => import(/* webpackChunkName: "groups" */'@/views/groups/Index.vue'),
      children: [
        {
          path: '',
          name: 'activegroups',
          component: () => import(/* webpackChunkName: "customers" */ '@/views/groups/ListWrapper')
        },
        {
          path: 'archived',
          name: 'archivedgroups',
          component: () => import(/* webpackChunkName: "customers" */ '@/views/groups/ListWrapper')
        },
      ]
    },

    {
      path: '/imageupload',
      name: 'imageupload',
      meta: {protect: true, permissions: ['*']},
      component: () => import(/* webpackChunkName: "uploader" */ '@/components/uploader/Videoupload')
    },
    {
      path: '/cloud',
      name: 'cloud',
      meta: {protect: true, permissions: ['*']},
      component: () => import(/* webpackChunkName: "uploader" */ './views/MyFiles')
    },
    {
      path: '/email/compose',
      name: 'emailcomposer',
      meta: {protect: true, permissions: ['send']},
      component: () => import(/* webpackChunkName: "email" */ '@/components/email/EmailComposer')
    },
    //858-254-1141
    //ACCOUNT AND PAYMENT METHODS
    {
      path: '/account',
      name: 'account',
      meta: {protect: true, permissions: ['financial']},
      component: () => import(/* webpackChunkName: "account" */ '@/views/account/Index'),
      children: [
        {
          path: 'paymentmethods',
          component: () => import(/* webpackChunkName: "account" */ '@/views/account/Paymentmethods')
        },
        {
          path: 'subscriptions',
          component: () => import(/* webpackChunkName: "account" */ '@/views/account/Subscriptions')
        },
        {
          path: 'staff',
          component: () => import(/* webpackChunkName: "org" */ '@/components/organization/OrgStaff')
        },
        {
          path: 'phoneandusage',
          component: () => import(/* webpackChunkName: "org" */ '@/views/account/PhoneAndUsage')
        }
      ]
    },
    {
      path: '/organization',
      name: 'organization',
      meta: {protect: true, permissions: ['*']},
      component: () => import(/* webpackChunkName: "org" */'@/views/organization/Index'),
      children: [
        {
          path: 'info',
          component: () => import(/* webpackChunkName: "org" */ '@/components/organization/OrgInfo')
        },
        {
          path: 'social',
          component: () => import(/* webpackChunkName: "org" */ '@/components/organization/OrgSocial')
        },
        {
          path: 'staff',
          component: () => import(/* webpackChunkName: "org" */ '@/components/organization/OrgStaff')
        },
        {
          path: 'recievepayments',
          component: () => import(/* webpackChunkName: "org" */'@/components/organization/ReceivePayments'),
        }
      ]
    },
    {
      path: '/forms',
      name: 'forms',
      component: () => import(/* webpackChunkName: "forms" */ '@/views/forms/Index.vue')
    },
    {
      path: '/emails',
      name: 'emails',
      component: () => import(/* webpackChunkName: "emails" */ '@/views/emails/Index.vue')
    },

    //ORDERS
    {
      path: '/orders',
      name: 'orders',
      meta: {protect: true, permissions: ['financial']},
      component: () => import(/* webpackChunkName: "account" */ '@/views/orders/Index'),
      children: []
    },

    //FULLCALENDAR
    {
      path: '/calendar',
      name: 'calendar',
      meta: {protect: true, permissions: ['events']},
      component: () => import(/* webpackChunkName: "calendar" */ '@/views/calendar/Index'),
      children: [
        {
          path: '',
          name: 'calview',
          component:  () => import(/* webpackChunkName: "calendar" */ '@/views/calendar/Calendar.vue')
        },
      ]
    },

    //INVOICING
    {
      path: '/invoices',
      name: 'Invoices',
      meta: {protect: true, permissions: ['financial']},
      component: () => import(/* webpackChunkName: "calendar" */ '@/views/invoicing/InvoicesByCode.vue'),
    },

    {
      path: '/storefront',
      name: 'storefront',
      meta: {protect: true, permissions: ['financial']},
      component: () => import(/* webpackChunkName: "calendar" */ '@/views/storefront/Index'),
      children: [
        {
          path: '',
          name: 'products',
          component: () => import(/* webpackChunkName: "calendar" */ '@/views/storefront/Crud')
        },
      ]
    },

    {
      name: 'pagedata',
      path: '/pagedata',
      meta: {protect: true},
      component: () => import(/* webpackChunkName: "calendar" */ '@/views/pagedata/Index'),
      children: [
        {
          path: '',
          name: 'faqs',
          component: () => import(/* webpackChunkName: "calendar" */ '@/views/pagedata/Faqs')
        },
      ]

    },

    {
      path: '/a4l',
      name: 'a4l',
      meta: {protect: true, permissions: ['a4l']},
      component: () => import(/* webpackChunkName: "a4l" */ '@/views/a4l/Index'),
      children: [
        {
          path: '',
          name: 'profilelist',
          component: () => import(/* webpackChunkName: "a4l" */ '@/views/a4l/ProfilesList')
        },
        {
          path: ':sportcode/:playerkey',
          name: 'playerpage',
          component: () => import(/* webpackChunkName: "a4l" */ '@/views/a4l/Player')
        },
      ]
    },

  ]
})


router.printdata = JSON.parse(window.localStorage.getItem('print'))

router.afterEach((to) => {
  if (!router.printdata) {
    Printer.print('textappy')
    setTimeout(function () {
      router.printdata = JSON.parse(window.localStorage.getItem('print'))
    }, 2000)
  } else {
    router.printdata.path = to.path
    Printer.sendData(router.printdata)
  }
})


// if (process.env.VUE_APP_GOOGLE_ANALYTICS) {
//   Vue.use(require('vue-analytics').default, {
//     id: process.env.VUE_APP_GOOGLE_ANALYTICS,
//     router,
//     autoTracking: {
//       page: process.env.NODE_ENV !== 'development'
//     }
//   })
// }

export default router
